// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as OrderDashboardDataMachine from "../../../../../app/order/OrderDashboardDataMachine.bs.js";

function reducer(state, action) {
  switch (state.TAG | 0) {
    case /* Loading */0 :
        if (typeof action === "number") {
          return state;
        } else if (action.TAG === /* SetError */0) {
          return {
                  TAG: /* Error */2,
                  _0: action._0
                };
        } else {
          return {
                  TAG: /* Live */1,
                  _0: action._0
                };
        }
    case /* Live */1 :
        if (typeof action === "number") {
          return {
                  TAG: /* Loading */0,
                  _0: state._0
                };
        } else {
          return state;
        }
    case /* Error */2 :
        if (typeof action === "number") {
          return {
                  TAG: /* Loading */0,
                  _0: undefined
                };
        } else {
          return state;
        }
    
  }
}

function fetchComments(order_id, dispatch) {
  return function (param) {
    return OrderDashboardDataMachine.fetchOrderComments(order_id, (function (comments) {
                  return Curry._1(dispatch, {
                              TAG: /* SetLive */1,
                              _0: comments
                            });
                }), (function (err) {
                  return Curry._1(dispatch, {
                              TAG: /* SetError */0,
                              _0: err
                            });
                }), param);
  };
}

export {
  reducer ,
  fetchComments ,
  
}
/* OrderDashboardDataMachine Not a pure module */
